export default __webpack_public_path__ + "static/vaden-mobil-katalog-yazilimi-6f61d3feb90e8408c5139f45f5d4c1c4.png";